import { render, staticRenderFns } from "./AstaSvincolati.vue?vue&type=template&id=1e6dd10d&scoped=true&"
import script from "./AstaSvincolati.vue?vue&type=script&lang=js&"
export * from "./AstaSvincolati.vue?vue&type=script&lang=js&"
import style0 from "./AstaSvincolati.vue?vue&type=style&index=0&id=1e6dd10d&lang=scss&scoped=true&"
import style1 from "./AstaSvincolati.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6dd10d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e6dd10d')) {
      api.createRecord('1e6dd10d', component.options)
    } else {
      api.reload('1e6dd10d', component.options)
    }
    module.hot.accept("./AstaSvincolati.vue?vue&type=template&id=1e6dd10d&scoped=true&", function () {
      api.rerender('1e6dd10d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaSvincolati.vue"
export default component.exports